import React from 'react';

import { Grid } from '@sunwisesoftware/sunwise-ui';
import { push } from 'connected-react-router';
import get from 'lodash/get';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { connect } from 'react-redux';

import {
    ChipProposalStatus,
    CollapsedBreadcrumbs,
    ProposalStatusIcon,
    TitleIcon,
} from 'common/components';
import IconPreview from 'common/components/icons/IconPreview';
import { PROPOSAL_STATUS } from 'common/constants';
import { getStatusProposalLabel } from 'common/utils/helpers';

const HeaderPreview = ({ headerRef, proposalDetails, redirect }) => {
    const { t } = useTranslation();
    const isGenerated =
        proposalDetails?.render_status === PROPOSAL_STATUS.GENERATED;

    const project = get(proposalDetails, 'project', {});
    const isBomExpress = get(proposalDetails, 'is_bom_express', false);
    const contact = get(project, 'contact', {});
    const layoutUrl = isBomExpress ? `bom-express` : `panel-layout`;
    const contactUrl = `contacts/${contact?.id}`;

    const breadcrumbLocations = [
        {
            label: contact?.name,
            action: () => redirect(`/${contactUrl}`),
        },
        {
            label: project?.name,
            action: () => redirect(`/${contactUrl}/${project?.id}`),
        },
        {
            label: isBomExpress ? t('Express') : t('Professional'),
            action: () =>
                redirect(`/${layoutUrl}/${proposalDetails?.designer?.id}`),
        },
    ];

    return (
        <Grid
            container
            ref={headerRef}
            sx={{
                alignItems: 'center',
                paddingBottom: '1rem',
                paddingTop: '1rem',
                px: 2,
            }}
        >
            <Grid size={{ lg: 15, md: 14, xs: 13 }}>
                <TitleIcon
                    icon={<IconPreview color="#2AA1E0" />}
                    title={t('Preview')}
                />
            </Grid>

            <Grid size={{ lg: 3, md: 4, xs: 5 }} textAlign="right">
                <ChipProposalStatus
                    icon={<ProposalStatusIcon isGenerated={isGenerated} />}
                    label={getStatusProposalLabel(isGenerated)}
                />
            </Grid>

            <CollapsedBreadcrumbs
                current={proposalDetails.name}
                locations={breadcrumbLocations}
            />
        </Grid>
    );
};

HeaderPreview.propTypes = {
    headerRef: PropTypes.object,
    proposalDetails: PropTypes.object,
    redirect: PropTypes.func,
};

const mapDispatchToProps = (dispatch) => ({
    redirect: (link) => dispatch(push(link)),
});

export default connect(null, mapDispatchToProps)(HeaderPreview);
